import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_PAISES = `${API_URL}/ih/paises`;
const GET_TIPVIA = `${API_URL}/ih/tipoVias/`;
const GET_LOCALIDADES = `${API_URL}/ih/localidades`;
const GET_PROVINCIAS = `${API_URL}/ih/provincias`;
const GET_MUNICIPIOS = `${API_URL}/ih/municipios`;

export async function getIhPaises() {
  return await axios({
    method: "GET",
    url: GET_PAISES,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger los paises")
    );
}

export async function getIhTipVia() {
  return await axios({
    method: "GET",
    url: GET_TIPVIA,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger los tipo de vías")
    );
}

export async function getIhProvincias(cpais) {
  return await axios({
    method: "GET",
    url: `${GET_PROVINCIAS}/${cpais}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger las provincias")
    );
}

export async function getIhMunicipios(cpais, cprovincia,) {
  return await axios({
    method: "GET",
    url: `${GET_MUNICIPIOS}/${cpais}/${cprovincia}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger los municipios")
    );
}


export async function getIhLocalidades(cpais, cprovincia, cmunicipio) {
  return await axios({
    method: "GET",
    url: `${GET_LOCALIDADES}/${cpais}/${cprovincia}/${cmunicipio}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger las localidades")
    );
}

